import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useTranslation } from 'react-i18next';
import PrivateFillIcon from '@wix/da-ds/pkg/Icons/24x24/PrivateFill';
import PrivateIcon from '@wix/da-ds/pkg/Icons/24x24/Private';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../../_partials/ActionBarButtonRestricted';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { NotificationType } from '../../../../Notifications';
import { getIsPrivatelyCollected } from '../../../../CollectionPanel/redux/selectors';
const AddToPrivateCollectionButton = ({ deviation , onClick  })=>{
    const { t  } = useTranslation();
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const isPrivatelyCollected = useSelector((state)=>getIsPrivatelyCollected(state, deviation));
    const clickHandler = useCallback(()=>{
        onClick(deviation);
    }, [
        onClick,
        deviation
    ]);
    const tooltip = t('comment.action.addToPrivate.tooltip');
    return /*#__PURE__*/ React.createElement(ActionBarButtonRestricted, {
        deviation: deviation,
        tooltip: tooltip,
        notificationTypes: [
            NotificationType.CollectPrivate
        ],
        button: /*#__PURE__*/ React.createElement(ActionBarButton, {
            onClick: restrictToLoggedIn(ReferralType.ADD_TO_PRIVATE_COLLECTION, clickHandler),
            "aria-label": tooltip,
            biData: BiData({
                evid: 334,
                creatorid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                typeid: BiContextProvidedValue,
                itemid: BiContextProvidedValue
            })
        }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
            icon: isPrivatelyCollected ? PrivateFillIcon : PrivateIcon
        }))
    });
};
AddToPrivateCollectionButton.displayName = 'AddToPrivateCollectionButton';
export default AddToPrivateCollectionButton;
